import { Tbody } from "@chakra-ui/react";
import Row from "./Row";
import type { TBodyProps } from "./TBody.d";

const TBody = ({ rows }: TBodyProps) => (
  <Tbody>
    {rows.map((row, idx) => (
      <Row key={row.id} row={row} isLast={rows.length - 1 === idx} />
    ))}
  </Tbody>
);

export default TBody;
